import React, { useEffect, useState } from "react";
import "./documantation.css";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import { getTrans as t } from "../../Localization/translations";
import UserGuideService from "../../services/userGuide/userGuideService";

export default function Documentation() {
    const [guides, setGuides] = useState([]);
    const [selectedGuide, setSelectedGuide] = useState(null);

    const [search, setSearch] = useState("");
    const [results, setResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth <= 767.98 : false);

    // handle mobile breakpoint
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= 767.98);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // 📘 Load guides
    useEffect(() => {
        UserGuideService.getGuides()
            .then((res) => {
                const data = res.data?.data || res.data || [];
                setGuides(data);
                if (data.length > 0) setSelectedGuide(data[0]);
            })
            .catch((err) => console.error("Guide fetch error:", err));
    }, []);

    // 🔍 Global search
    useEffect(() => {
        if (!search) {
            setResults([]);
            return;
        }

        const debounce = setTimeout(() => {
            setSearchLoading(true);
            UserGuideService.globalSearch(search)
                .then((res) => setResults(res.data?.results || []))
                .catch(console.error)
                .finally(() => setSearchLoading(false));
        }, 300);

        return () => clearTimeout(debounce);
    }, [search]);

    const handleResultClick = (result) => {
        const guide = guides.find((g) => g.id === result.guide_id);
        if (!guide) return;

        setSelectedGuide(guide);
        setSearch("");
        setResults([]);
    };


    return (
        <div className="doc-page">
            <main className="doc-main">
                <div className="container-fluid h-100 py-3">
                    <div className="row g-3 h-100">

                        {/* LEFT: NAVIGATION */}
                        <div className="col-xl-2 col-lg-3 col-md-12 h-100 doc-left">
                            <div className="h-100">
                                {/* On small screens render a select dropdown instead of tabs */}
                                {isMobile ? (
                                    <div className="px-2">
                                        <select
                                            className="form-select mb-2"
                                            value={selectedGuide?.id || ""}
                                            onChange={(e) => {
                                                const guide = guides.find((g) => String(g.id) === e.target.value);
                                                if (guide) {
                                                    setSelectedGuide(guide);
                                                    setSearch("");
                                                    setResults([]);
                                                }
                                            }}
                                        >
                                            <option value="">{t("Select a document")}</option>
                                            {guides.map((guide) => (
                                                <option key={guide.id} value={guide.id}>
                                                    {guide.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    <Tabs
                                        selectedIndex={guides.findIndex((g) => g.id === selectedGuide?.id)}
                                        onSelect={(index) => {
                                            const guide = guides[index];
                                            if (guide) {
                                                setSelectedGuide(guide);
                                                setSearch("");
                                                setResults([]);
                                            }
                                        }}
                                    >
                                        <TabList>
                                            {guides.map((guide) => (
                                                <Tab key={guide.id}>
                                                    <p>{guide.title}</p>
                                                </Tab>
                                            ))}
                                        </TabList>
                                    </Tabs>
                                )}
                            </div>
                        </div>

                        {/* CENTER: PDF VIEWER */}
                        <div className="col-xl-7 col-lg-6 col-md-12 h-100">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body p-0" style={{ height: "100%" }}>
                                    {selectedGuide?.file ? (
                                        <iframe
                                            src={selectedGuide.file}
                                            title="User Guide PDF"
                                            className="doc-iframe"
                                            width="100%"
                                            height="100%"
                                            style={{ border: "none", display: "block" }}
                                        />
                                    ) : (
                                        <div className="d-flex justify-content-center align-items-center h-100 text-muted">
                                            {t("Select a document to view")}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* RIGHT: SEARCH */}
                        <div className="col-xl-3 col-lg-3 col-md-12 h-100 doc-right">
                            <div className="card h-100 shadow-sm">
                                <div className="card-body d-flex flex-column">
                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        placeholder={t("Search")}
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />

                                    {search && (
                                        <div className="search-results" style={{ fontSize: "14px" }}>


                                            {searchLoading ? (
                                                <div>{t("Searching...")}</div>
                                            ) : results.length === 0 ? (
                                                <div>{t("No results found")}</div>
                                            ) : (
                                                results.map((r, index) => (
                                                    <div
                                                        key={index}
                                                        className="border-bottom py-2"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleResultClick(r)}
                                                    >
                                                        <strong>
                                                            {r.type === "navigation" ? "📁" : "📄"} {r.title}
                                                        </strong>
                                                        {r.page && (
                                                            <span className="text-muted">
                                                                {" "}— Page {r.page}
                                                            </span>
                                                        )}
                                                        {r.text && (
                                                            <div className="search-result-text">
                                                                {r.text}
                                                            </div>
                                                        )}

                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    );
}